import { FC, useEffect, useState } from "react";

import { Layout } from "../components/Layout";
import { Spinner } from "../components/Spinner";
import { HistoryItems } from "../components/HistoryItems";
import { SimpleFadeIn } from "../components/SimpleFadeIn";
import { RouteKey } from "../configs/routes";
import { HistoryItem } from "../utils/context";
import { getPersistedHistory } from "../utils/api";
import { useStorage } from "../utils/useStorage";

export const History: FC = () => {
  const { removeDrink } = useStorage();

  const [isLoading, setLoading] = useState(true);
  const [history, setHistory] = useState<HistoryItem[]>([]);

  const reload = () => getPersistedHistory().then(setHistory).then(() => setLoading(false));

  const handleRemove = (item: HistoryItem) => {
    removeDrink && removeDrink(item).then(reload);
  }

  useEffect(() => {
    reload();
  }, []);

  const content = (() => {
    if (isLoading) {
      return (
        <SimpleFadeIn>
          <Spinner />
        </SimpleFadeIn>
      );
    }

    return <HistoryItems items={history} onRemove={handleRemove} />;
  })();

  return (
    <Layout route={RouteKey.HISTORY}>
      {content}
    </Layout>
  );
}